module.exports = __webpack_public_path__ + "static/media/tst.903cd60d.svg";